import { appAxios } from "@/core/utils/appAxios";
import { eff } from "@/core/utils/effect-ts-abbr";
import { environment } from "@/environments/environment";
import { appCompanyStatusDialogModel } from "@/shared/components/app-company-status-dialog/app-company-status-dialog.model";
import { appLanguageSwitcherModel } from "@/shared/components/app-language-switcher/app-language-switcher.model";
import { useI18n } from "@/shared/composables/use-i18n";
import { pageLoaderModel } from "@/shared/models/page-loader";
import { currentUserModel } from "@/shared/state/current-user.model";
import { watch, watchEffect } from "vue";
import { setup, Vue } from "vue-class-component";
import { Options } from "vue-property-decorator";
import DashboardSidebar from "../dashboard-sidebar/dashboard-sidebar.vue";
import { dashboardModel } from "../dashboard.model";
import AccountManager from "@/dashboard/my-account/account-manager/account-manager.vue";
import { sessionModel } from "@/shared/state/session.model";
import { getEnvValue } from "@/shared/models/environment";

const HIDE_ACCOUNT_MANAGER_BRANDS = ["astara"];

type WelcomePageData = {
    readonly sections: readonly {
        readonly layout: string;
        readonly attributes: {
            readonly title: string;
            readonly description: string;
            readonly link: string;
            readonly icon: string;
        };
    }[];
    readonly top_card_title: "";
    readonly top_card_background: "";
    readonly top_card_description: "";
};

@Options({
    components: {
        "dashboard-sidebar": DashboardSidebar,
        "app-account-manager": AccountManager,
    },
})
export class WelcomePage extends Vue {
    i18n = setup(useI18n);
    pageLoader = pageLoaderModel;
    appCompanyStatusDialogModel = appCompanyStatusDialogModel;
    environment = environment;
    storageApi = environment.storageApi;

    pageData: WelcomePageData = {
        sections: [],
        top_card_title: "",
        top_card_background: "",
        top_card_description: "",
    };

    ordersQuantity = 0;

    pageIcons: eff.dict.Dictionary<string> = {};

    get canShowOrdersPage(): boolean {
        return dashboardModel.canShowOrdersPage.value;
    }

    get isProspect() {
        return !sessionModel.JWTUserDto.value?.id_customer;
    }

    get filteredPageData() {
        console.log(this.pageData);
        const result = {
            ...this.pageData,
            sections: eff.fn.pipe(
                this.pageData.sections,
                eff.array.filter(({ attributes: { link } }) => this.canShowLink(link)),
            ),
        };
        return result;
    }

    canShowLink(link: string): boolean {
        switch (link) {
            // case "/auth/my-carconnex/my-car-history":
            //     return dashboardModel.canShowOrderHistoryPage.value;
            case "/auth/my-carconnex/my-favorites":
                return dashboardModel.canShowFavoritesPage.value;
            case "/auth/my-carconnex/my-orders/to_approve":
                return dashboardModel.canShowOrdersPage.value;
        }

        return true;
    }

    beforeMount() {
        this.pageLoader.toggle(true);
    }

    mounted() {
        watch(
            () => appLanguageSwitcherModel.lang.value,
            async (AppLanguageCode) => {
                await eff.fn.pipe(
                    eff.t.promise(() =>
                        appAxios.value.get<{ readonly data: WelcomePageData }>(
                            `/api/pages/${AppLanguageCode}/dashboard`,
                            { validateStatus: () => true },
                        ),
                    ),
                    eff.t.chain((response) =>
                        eff.fn.pipe(
                            response.status === 200,
                            eff.bool.fold(
                                () => eff.t.fail(response),
                                () => eff.t.succeed(response),
                            ),
                        ),
                    ),
                    eff.t.tap((response) =>
                        eff.t.succeedWith(() => {
                            this.pageData = {
                                ...response.data.data,
                                sections: response.data.data.sections.filter(
                                    (_) =>
                                        _.attributes.link !==
                                        "/my-carconnex/my-settings" &&
                                        _.attributes.link !==
                                        "/my-carconnex/my-car-history",
                                ),
                            };
                            this.pageLoader.toggle(false);
                        }),
                    ),
                    eff.t.runPromiseExit,
                );
            },
            { immediate: true },
        );

        /** watchEffect(async () => {
            await eff.fn.pipe(
                eff.t.promise(() =>
                    appAxios.value.get<
                        APIResponse<{ body: OrderDto[]; meta: Pagination }>
                    >("/client/web/orders", { data: { page: 0, items_per_page: 0 } }),
                ),
                eff.t.chain((response) =>
                    eff.fn.pipe(
                        response.status === 200,
                        eff.bool.fold(
                            () => eff.t.fail(response),
                            () => eff.t.succeed(response),
                        ),
                    ),
                ),
                eff.t.tap((response) =>
                    eff.t.succeedWith(() => {
                        this.ordersQuantity = response.data.data.meta.total;
                    }),
                ),
                eff.t.runPromiseExit,
            );
        }); **/
    }

    get userFullName(): string | undefined {
        return (
            currentUserModel.userDto.value &&
            currentUserModel.userDto.value?.firstname +
            " " +
            currentUserModel.userDto.value?.lastname
        );
    }

    get brandLabel() {
        return getEnvValue("BRAND_LABEL");
    }

    get shouldHideAccountManager() {
        return HIDE_ACCOUNT_MANAGER_BRANDS.includes(this.brandLabel);
    }
}
